<template>
	<div class="action-button-wrapper divide">
      <b-button size="sm" class="site-action-btn" variant="link" target="_blank" :href="serverURL+'ajax.php?action=loadSite&siteID='+site.siteID">
          <span class="icon-cont">
              <open-admin-icon class="icon-default open-admin-icon"></open-admin-icon>
          </span>
          <span>open admin in new tab</span>
      </b-button>
  </div>
</template>

<script>
import OpenAdminIcon from '../../assets/openadmin.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	OpenAdminIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
};
</script>